export default __webpack_public_path__ + "static/media/plus26-33.6d38f43d.png";